/**
 * Ce que l'overlay `taverne` (le QR code du stream) tient de fixe. Cet overlay passe a l'ecran du stream : son
 * seul texte est la ligne sous le QR code, et aucune panne ne s'y ecrit jamais (elle se lit dans la regie).
 */

/** Le nom que l'overlay se donne sur le flux : la regie le liste parmi les overlays connectes. */
export const NOM_TAVERNE = "taverne";

/** La ligne sous le QR code. */
export const QR_LIGNE = "Rejoins le château";

/** Le QR code, un fichier du frontal (`public/images`, provenance dans `PROVENANCE.md`). */
export const QR_IMAGE = "/images/qr-rejoindre.svg";

/** Ce que lit un lecteur d'ecran : l'adresse que le QR code ouvre. */
export const QR_ALT = "QR code : taverne.kavaliero.fr/rejoindre";

/**
 * Le cote du QR code a l'ecran, en pixels CSS : **41 modules x 5 pixels**. Les 41 modules sont les 33 du symbole et
 * sa marge de 4 de chaque cote. Un cote qui n'est pas un multiple de 41 donne des modules de 4 ou 5 pixels en
 * alternance, que les decodeurs les plus fragiles lisent mal ; `taverne.test.tsx` garde ce rapport.
 */
export const QR_COTE_PX = 205;

/** La distance entre le panneau et les deux bords de l'ecran qu'il touche, en pixels (de quoi rester dans la zone sure). */
export const MARGE_PX = 40;

/** Une lecture des reglages qui a echoue est refaite apres ce delai, jusqu'a ce qu'elle reussisse. */
export const DELAI_RELECTURE_MS = 5_000;

/** Une lecture qui n'a pas de reponse au bout de ce delai est abandonnee, puis refaite. */
export const DELAI_LECTURE_MS = 10_000;

/** Une image qui n'arrive pas (erreur ou 404) est redemandee apres ce delai, jusqu'a ce qu'elle arrive. */
export const DELAI_IMAGE_MS = 5_000;

/** La police du titre de La Taverne, que le panneau emploie : chargee a l'avance, pour ne pas montrer une police de repli. */
export const POLICE_LIGNE = '26px "New Rocker"';
